import { isResourceDetailDocumentPDF } from '../../resources/documentGuards.js';
import { isResourceDetailDocument } from '../../resources/utils/resourceDetailGuards.js';
import { maxDocumentPreviewSize } from '../resource-details.config.js';

const useDocumentPreviewable = (resource) => {
  const isDocument = resource ? isResourceDetailDocument(resource) : false;
  const isDocumentPDF = resource ? isResourceDetailDocumentPDF(resource) : false;
  return isDocumentPDF || isDocument && resource?.size && resource.size <= maxDocumentPreviewSize;
};

export { useDocumentPreviewable as default };
//# sourceMappingURL=useDocumentPreviewable.js.map
